<template>
  <div class="password-checker">
    <ul>
      <li>Meet the following requirements:</li>
      <li>
        <span>
          <img src="@/assets/icons/icon-close.svg" v-if="!minimum" class="icon-error" alt="error" />
          <img src="@/assets/icons/icon-check.svg" v-else class="icon-success" alt="success" />
        </span>
        At least 8 characters
      </li>
      <li>
        <span>
   <img src="@/assets/icons/icon-close.svg" v-if="!lowerCase" class="icon-error" alt="error" />
          <img src="@/assets/icons/icon-check.svg" v-else class="icon-success" alt="success" />
        </span>
        At least one lowercase letter
      </li>
      <li>
        <span>
          <img src="@/assets/icons/icon-close.svg" v-if="!upperCase" class="icon-error" alt="error" />
          <img src="@/assets/icons/icon-check.svg" v-else class="icon-success" alt="success" />
        </span>
        At least one uppercase letter
      </li>
      <li>
        <span>
          <img src="@/assets/icons/icon-close.svg" v-if="!numbers" class="icon-error" alt="error" />
          <img src="@/assets/icons/icon-check.svg" v-else class="icon-success" alt="success" />
        </span>
        At least one number
      </li>
      <li>
        <span>
          <img src="@/assets/icons/icon-close.svg" v-if="!symbols" class="icon-error" alt="error" />
          <img src="@/assets/icons/icon-check.svg" v-else class="icon-success" alt="success" />
        </span>
        At least one symbol
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PasswordChecker",

  props: {
    password: { type: String, default: '' }
  },

  computed: {
    /**
     * Makes the password require at least 8 characters.
     * @returns {boolean}
     */
    minimum() {
      return this.password.length >= 8
    },

    /**
     * Makes the password require at least one lowercase letter.
     * @returns {boolean}
     */
    lowerCase() {
      return /(?=.*[a-z])/.test(this.password)
    },

    /**
     * Makes the password require at least one uppercase letter.
     * @returns {boolean}
     */
    upperCase() {
      return /(?=.*[A-Z])/.test(this.password)
    },

    /**
     * Makes the password require at least one number.
     * @returns {boolean}
     */
    numbers() {
      return /(?=.*\d)/.test(this.password)
    },

    /**
     * Makes the password require at least one symbol.
     * @returns {boolean}
     */
    symbols() {
      return /(?=.*\W)/.test(this.password)
    }
  }
}
</script>

<style scoped lang="scss">
.password-checker {
  display: block;
  z-index: 10;
  position: absolute;
  padding: 0 0.75rem;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 13.125rem;
  background: #FFFFFF;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;

  ul {
    padding: 0;
    list-style: none;
    li {
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1rem;

      span {
        margin-right: 0.313rem;
        width: 0.875rem;
      }

      &:not(:first-child) {
        display: flex;
        align-items: center;
        margin: 0 auto;
      }

      &:first-child {
        font-weight: 700;
        color: #868292;;
      }

      &.invalid {
        color: #E8004C;
      }

      &.valid {
        color: #1BC000;
      }

      .icon-error {
        path {
          fill: #E8004C;
        }
      }
      .icon-success {
        path {
          fill: #27FF04;
        }
      }
    }
  }
}
</style>